/**
 * @generated SignedSource<<903d102d1f9710a849a77abdb436f7b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type controllertype = "C18" | "C78" | "UNKNOWN" | "%future added value";
export type ControllersRefetchQuery$variables = {
  controllerReleaseUuid?: string | null;
  controllerTypes?: ReadonlyArray<controllertype | null> | null;
  count?: number | null;
  cursor?: string | null;
  organizationUuid?: string | null;
  searchTerm?: string | null;
};
export type ControllersRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ControllersList_controllers">;
};
export type ControllersRefetchQuery = {
  response: ControllersRefetchQuery$data;
  variables: ControllersRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "controllerReleaseUuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "controllerTypes"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationUuid"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "controllerReleaseUuid",
    "variableName": "controllerReleaseUuid"
  },
  {
    "kind": "Variable",
    "name": "controllerTypes",
    "variableName": "controllerTypes"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Variable",
    "name": "organizationUuid",
    "variableName": "organizationUuid"
  },
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ControllersRefetchQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ControllersList_controllers"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ControllersRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ControllerConnection",
        "kind": "LinkedField",
        "name": "controllers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ControllerEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Controller",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uuid",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "controllerId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "controllerType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "skydioSerial",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "organizationId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Organization",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ControllerRelease",
                    "kind": "LinkedField",
                    "name": "controllerRelease",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "releaseKey",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "versionString",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "searchTerm",
          "organizationUuid",
          "controllerReleaseUuid",
          "controllerTypes"
        ],
        "handle": "connection",
        "key": "ControllersList_controllers",
        "kind": "LinkedHandle",
        "name": "controllers"
      }
    ]
  },
  "params": {
    "cacheID": "d4f0e83302b952f36c1b97c6236711b3",
    "id": null,
    "metadata": {},
    "name": "ControllersRefetchQuery",
    "operationKind": "query",
    "text": "query ControllersRefetchQuery(\n  $controllerReleaseUuid: String\n  $controllerTypes: [controllertype]\n  $count: Int\n  $cursor: String\n  $organizationUuid: String\n  $searchTerm: String\n) {\n  ...ControllersList_controllers\n}\n\nfragment ControllersList_controllers on Query {\n  controllers(searchTerm: $searchTerm, organizationUuid: $organizationUuid, controllerReleaseUuid: $controllerReleaseUuid, controllerTypes: $controllerTypes, first: $count, after: $cursor) {\n    totalCount\n    edges {\n      node {\n        id\n        uuid\n        name\n        controllerId\n        controllerType\n        skydioSerial\n        organizationId\n        organization {\n          id\n          name\n        }\n        controllerRelease {\n          id\n          releaseKey\n          versionString\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "453132cb2c4ae5deb6fae21e11254f1c";

export default node;
